import { Mail, Linkedin, Heart } from "lucide-react";

export const Footer = () => {
  return (
    <footer
      data-testid="footer"
      className="w-full py-8 mt-12 flex flex-col sm:flex-row justify-between items-center gap-4 border-t border-[#1e293b]"
    >
      <p className="flex items-center gap-1.5 text-sm text-slate-500">
        Built with
        <Heart className="h-4 w-4 text-[#f5a524] fill-[#f5a524]" />
        by <span className="text-slate-200">Thamelnesan Nithyanandam</span>
      </p>
      <div className="flex items-center gap-5">
        <a
          data-testid="footer-email"
          href="mailto:mailtothamel@gmail.com"
          className="flex items-center gap-2 text-sm text-slate-500 hover:text-[#0cb0b5] transition-colors duration-200"
        >
          <Mail className="h-4 w-4" />
          Email
        </a>
        <a
          data-testid="footer-linkedin"
          href="https://www.linkedin.com/in/thamelnesan/"
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => {
            e.preventDefault();
            window.open(
              "https://www.linkedin.com/in/thamelnesan/",
              "_blank",
              "noopener,noreferrer"
            );
          }}
          className="flex items-center gap-2 text-sm text-slate-500 hover:text-[#0cb0b5] transition-colors duration-200"
        >
          <Linkedin className="h-4 w-4" />
          LinkedIn
        </a>
      </div>
    </footer>
  );
};
